import {
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BarChartComponent = ({ data }) => {
  const stages = ['Pending Login Activation', 'Pending Validation', 'Login Activated'];
  const labels = data.map(item => item.label);

  const datasets = stages.map((stage, index) => ({
    label: stage,
    data: data.map(item => item[stage]?.value || 0),
    backgroundColor: getStageColor(stage),
    actualValues: data.map(item => item[stage]?.actualValue || 0),
    stack: 'stack1',
  }));

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const dataset = context.dataset;
            const actualValue = dataset.actualValues?.[context.dataIndex] ?? '';
            return `${dataset.label}: ${context.raw}`;
          },
        },
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: '#000',
        font: {
          weight: 'bold',
        },
        formatter: (value) => (value > 0 ? `${value}` : ''),
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#333',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#333',
          font: {
            size: 12,
          },
        },
      },
    },
  };

  function getStageColor(stage) {
    const colorMap = {
      'Pending Login Activation': '#FF6384',
      'Pending Validation': '#36A2EB',
      'Login Activated': '#FFCE56',
    };
    return colorMap[stage] || '#AAA';
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '500px',
        display: 'flex',
        justifyContent: 'center',
        borderRadius: '2px',
        overflow: 'hidden',
        backgroundColor: '#fff',
      }}
    >
      <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default BarChartComponent;
